import Scene = Phaser.Scene;
import {Fonts} from "@/constants/font";
import Text = Phaser.GameObjects.Text;
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class SquareButton extends Phaser.GameObjects.Container {

    private callback: (() => unknown) | undefined = undefined;
    private buttonText!: Text;

    constructor(scene: Scene, x: number, y: number, imageShift: number,
                frameKey: string,
                atlas: string | undefined, key: string | undefined,
                text: string, pale: boolean, imageSizeX?: number, imageSizeY?: number, buttonTextY?: number, fontSize?: number, fontFamily?: string) {
        super(scene);

        this.scene = scene;
        this.x = x * CU.S;
        this.y = y * CU.S;
        const self = this;

        let button;
        if ([Keys.UI_ART_GREEN_BUTTON, Keys.UI_ART_BROWN_BUTTON, Keys.UI_ART_PALE_BUTTON,
            Keys.UI_ART_RED_BUTTON, Keys.UI_SQUARE_FRAME].includes(frameKey)) {
            button = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_PROFILE, frameKey).setInteractive();
        } else {
            button = SpriteUtils.addImage(this.scene, 0, 0, frameKey).setInteractive();
        }

        button.on('pointerdown', () => {
            SpriteUtils.scaleOriginal(self, self.scale * 1.01);
        });
        button.on('pointerup', () => {
            SpriteUtils.scaleOriginal(self, self.scale / 1.01);
            if (self.callback != null) {
                self.callback();
            }
        });

        button.setOrigin(0.5, 0.5);
        this.add(button);

        if (key) {
            const image = !!atlas ? SpriteUtils.addImage(this.scene, 0, imageShift, atlas, key) : SpriteUtils.addImage(this.scene, 0, imageShift, key);
            if (imageSizeX && imageSizeY) {
                SpriteUtils.setDispSize(image, imageSizeX, imageSizeY);
            }
            this.add(image);
        }

        this.buttonText = this.scene.add.text(0, (buttonTextY ? buttonTextY : 80) * CU.S, text.toUpperCase(),{
            fontSize: (Math.ceil((fontSize ? fontSize : 14) * CU.S)) + 'pt',
            color: pale ? '#a7a7a7' : '#ffffff',
            fontFamily: fontFamily? fontFamily : Fonts.MYRIADPRO_BOLD,
            align: 'center',
            fontStyle: 'normal',
            wordWrap: { width: 210 * CU.S, useAdvancedWrap: true }
        }).setOrigin(0.5, 0.5);
        this.buttonText.setShadow(-1, 2, '#000000');
        this.add(this.buttonText);
    }

    public setCallback(callback: () => unknown): void {
        this.callback = callback;
    }

    public setOrigin(x: number, y: number): void {
        // do nothing
    }

    public setText(text: string) {
        this.buttonText.setText(text);
    }

    public setTextY(y: number) {
        this.buttonText.y = y;
    }
}
